module.exports = __webpack_public_path__ + "static/media/faisalabad-dark.80ae30ec.svg";